import { configureStore } from '@reduxjs/toolkit';
import styleReducer from './styleSlice';
import mainReducer from './mainSlice';
import authSlice from './authSlice';
import openAiSlice from './openAiSlice';

import usersSlice from "./users/usersSlice";
import rolesSlice from "./roles/rolesSlice";
import permissionsSlice from "./permissions/permissionsSlice";
import schoolsSlice from "./schools/schoolsSlice";
import academic_yearsSlice from "./academic_years/academic_yearsSlice";
import classesSlice from "./classes/classesSlice";
import teachersSlice from "./teachers/teachersSlice";
import studentsSlice from "./students/studentsSlice";
import daily_journalsSlice from "./daily_journals/daily_journalsSlice";
import attendance_recordsSlice from "./attendance_records/attendance_recordsSlice";
import discipline_character_recordsSlice from "./discipline_character_records/discipline_character_recordsSlice";
import religious_guidance_recordsSlice from "./religious_guidance_records/religious_guidance_recordsSlice";
import student_consultationsSlice from "./student_consultations/student_consultationsSlice";
import parent_communicationsSlice from "./parent_communications/parent_communicationsSlice";
import quran_surahsSlice from "./quran_surahs/quran_surahsSlice";
import quran_memorization_targetsSlice from "./quran_memorization_targets/quran_memorization_targetsSlice";
import quran_memorization_submissionsSlice from "./quran_memorization_submissions/quran_memorization_submissionsSlice";

export const store = configureStore({
  reducer: {
    style: styleReducer,
    main: mainReducer,
    auth: authSlice,
    openAi: openAiSlice,

users: usersSlice,
roles: rolesSlice,
permissions: permissionsSlice,
schools: schoolsSlice,
academic_years: academic_yearsSlice,
classes: classesSlice,
teachers: teachersSlice,
students: studentsSlice,
daily_journals: daily_journalsSlice,
attendance_records: attendance_recordsSlice,
discipline_character_records: discipline_character_recordsSlice,
religious_guidance_records: religious_guidance_recordsSlice,
student_consultations: student_consultationsSlice,
parent_communications: parent_communicationsSlice,
quran_surahs: quran_surahsSlice,
quran_memorization_targets: quran_memorization_targetsSlice,
quran_memorization_submissions: quran_memorization_submissionsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
